export default __webpack_public_path__ + "static/media/telegram.f0ac19cc.svg";